import React, { useEffect } from 'react';
import { LayoutProps } from '@/types/types';
import styles from './styles.module.css';
import { useForm, FormProvider } from 'react-hook-form';
import classNames from 'classnames';

interface FormProps extends LayoutProps {
  defaultValues?: Record<string, any>;
  submitHandler: (data: Record<string, any>) => void;
  mode?: 'onSubmit' | 'onBlur' | 'onChange' | 'onTouched' | 'all';
  resetContext?: boolean;
  overflow?: 'auto' | 'hidden';
}

export const FormContext: React.FC<FormProps> = ({
  children,
  defaultValues,
  submitHandler,
  mode,
  resetContext,
  overflow = 'hidden',
}) => {
  const methods = useForm({ defaultValues, mode: mode || 'onSubmit' });
  const { handleSubmit, reset } = methods;
  const formStyles = classNames(styles.form, styles[overflow]);

  useEffect(() => {
    if (resetContext) {
      reset(defaultValues);
    }
  }, [defaultValues, reset, resetContext]);

  return (
    <FormProvider {...methods}>
      <form className={formStyles} onSubmit={handleSubmit(submitHandler)}>
        {children}
      </form>
    </FormProvider>
  );
};
